const STALE_BUILD_MESSAGES = [
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "unable to preload css for",
];

export function isStaleBuildError(error: Error | null) {
  if (!error) {
    return false;
  }

  const message = error.message.toLowerCase();

  return STALE_BUILD_MESSAGES.some((staleBuildMessage) =>
    message.includes(staleBuildMessage),
  );
}
